import { gql, useApolloClient, useMutation, } from '@apollo/client';
export const STEP_WRITE = gql `
  mutation writeStep($dossierId: Long, $step: String!) {
    write_step(dossierId: $dossierId, step: $step) 
  }
`;
export const useStepWriteMutation = (options) => useMutation(STEP_WRITE, options);
export const useStepWriteMutationPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.mutate(Object.assign(Object.assign({}, options), { mutation: STEP_WRITE, variables }));
};
